import { StyledMintModalHeader } from './MintModalHeader.styled';

const MintModalHeader = ({ title = 'Hello Warhead'}) => {
  return (
    <StyledMintModalHeader>
      <div className='mint-modal-title-stub-short' />
      <div className='mint-modal-title'>{title}</div>
      <div className='mint-modal-title-stub-long' />
      <div className='mint-modal-title-question'>
        <img className='mint-modal-icon' src='/assets/skull.svg' alt=""/>
      </div>
      <div className='mint-modal-title-stub-short' />
    </StyledMintModalHeader>
  );
};

export default MintModalHeader;
